module.exports = __webpack_public_path__ + "static/businesses_2-0b8bd7890f3450b687952a43b1025725.svg";